import axios from 'axios'
import Forms from '../..'
import MultiEmailsInput from '../../fields/MultiEmailsInput'
import { Tooltip } from 'bootstrap'

class PaymentConfirmation extends Forms {
    constructor(domElement = null) {
        super(domElement)

        this.toolTips = []

        this.addEventListeners()

        this.setEmailField()
        this.setCompanyIdField()
        this.setUserUidField()

        this.clearQueryParams()
    }

    clearQueryParams() {

    }

    setUserUidField() {
        const userData = window.localStorage.getItem('user_data')
        if (userData) {
            const parsedData = JSON.parse(userData)
            const { userUuid } = parsedData
            if (userUuid) {
                const $uidField = this.form.find('.user-uid-field')
                $uidField.val(userUuid)
            }
        }
    }

    setCompanyIdField() {
        const $countryField = this.form.find('.country-field')
        const $companyIdField = this.form.find('.company-id-field')

        if ($countryField.val() && $countryField.val() === 'RS') {
            //$companyIdField.val('')
            $companyIdField.parent().removeClass('d-none')
        } else {
            $companyIdField.parent().addClass('d-none')
        }
    }

    setEmailField() {
        const $emailField = this.form.find('.emails-field')
        const $container = this.form.find('.multiple-emails-field-container')

        $emailField.parent().addClass('lib-emails-org-input')
        this.EmailsField = new MultiEmailsInput($container[0], {
            placeholder: $emailField.attr('placeholder'),
            max: 3,
            onFocus: () => {
                this.toolTips = this.toolTips.filter(item => {
                    if (item.id === $emailField.attr('id')) {
                        item.toolTip.dispose()
                        return false
                    }

                    return true
                })
            },
            onChange: items => {
                $emailField.val(items.join(','))
                this.toolTips = this.toolTips.filter(item => {
                    if (item.id === $emailField.attr('id')) {
                        item.toolTip.dispose()
                        return false
                    }

                    return true
                })
            }
        })

        if ($emailField.val()) {
            const values = $emailField.val().split(',')
            this.EmailsField.setValues(values)
        }
    }

    addEventListeners() {
        // Hide & destroy tooltips
        this.form.on('click change', '.form-input.is-invalid', event => {
            const item = $(event.currentTarget)
            let fieldId

            if (item.hasClass('selectize-control')) {
                const field = item.parent().find('select')
                fieldId = field.attr('id')
            } else {
                fieldId = item.attr('id')
            }

            if (fieldId) {
                this.toolTips = this.toolTips.filter(item => {
                    if (item.id === fieldId) {
                        item.toolTip.dispose()
                        return false
                    }

                    return true
                })
            }
        })

        this.form.on('change', '.country-field', () => this.setCompanyIdField())
    }

    afterSubmit() {
        this.setEmailField()
        this.setCompanyIdField()
        this.setUserUidField()

        // Re-init of tooltips on invalid fields
        this.toolTips.forEach(item => {
            const { toolTip } = item
            toolTip.dispose()
        })

        this.toolTips = []

        this.form.find('.form-input.is-invalid').each((_, item) => {
            const $parentContainer = $(item).closest('.form-floating')
            const { tipErrorMessage } = $parentContainer.data()
            const inputId = $(item).attr('id')

            if (inputId && tipErrorMessage) {
                const toolTip = new Tooltip($parentContainer, {
                    trigger: 'manual',
                    placement: 'bottom',
                    customClass: 'required-tooltip',
                    title: tipErrorMessage,
                    container: this.form
                })

                this.toolTips.push({
                    id: inputId,
                    toolTip,
                })

                toolTip.show()
            }
        })

        this.scrollAfterSubmit()
    }
}

export default PaymentConfirmation
